import { createServerFn } from "@tanstack/react-start";
import { createAuthenticatedApiConfig } from "@/lib/utils.server";
import { useAppSession } from "@/utils/session";

export const fetchUser = createServerFn({ method: "GET" }).handler(async () => {
  try {
    const config = await createAuthenticatedApiConfig();

    if (!config) {
      throw new Error("Unauthenticated: Redirecting to login");
    }

    // We need to auth on the server so we have access to secure cookies
    const session = await useAppSession();

    if (!session.data.username || !session.data.token) {
      return null;
    }

    // Take care not to leak anything sensitive here since it is accessible to the client.
    return {
      username: session.data.username,
      displayName: session.data.displayName,
    };
  } catch (error) {
    console.error("Error fetching user:", error.message);
    return null;
  }
});
